<template>
  <a-modal :title="title" :width="width" :visible="visible" switchFullscreen @ok="handleSubmit" @cancel="handleCancel"
    :cancelText="$t('关闭')" :okButtonProps="{ class:{'jee-hidden': disabled} }">
    <div class="table-page-search-wrapper">
      <a-form-model layout="vertical" ref="formRef" :model="form" :rules="rules">
        <a-row :gutter="24">
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-model-item :label="$t('姓名')">
              <a-input :placeholder="$t('输入姓名')" v-model="form.name" :disabled="disabled"></a-input>
            </a-form-model-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-model-item :label="$t('性别')">
              <a-radio-group v-model="form.sex" :disabled="disabled">
                <a-radio :value="1">{{ $t('男') }}</a-radio>
                <a-radio :value="2">{{ $t('女') }}</a-radio>
              </a-radio-group>
            </a-form-model-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-model-item :label="$t('民族')">
              <a-input :placeholder="$t('输入民族')" v-model="form.ethnicGroup" :disabled="disabled"></a-input>
            </a-form-model-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-model-item :label="$t('职业')">
              <a-input :placeholder="$t('输入职业')" v-model="form.occupation" :disabled="disabled"></a-input>
            </a-form-model-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-model-item :label="$t('籍贯')">
              <a-input :placeholder="$t('输入籍贯')" v-model="form.origin" :disabled="disabled"></a-input>
            </a-form-model-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-model-item :label="$t('身份证号')">
              <a-input :placeholder="$t('输入身份证号')" v-model="form.ldentificationNumber" :disabled="disabled"></a-input>
            </a-form-model-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-model-item :label="$t('婚姻状况')">
              <a-radio-group v-model="form.marriageState" :disabled="disabled">
                <a-radio :value="1">{{ $t('已婚') }}</a-radio>
                <a-radio :value="2">{{ $t('未婚') }}</a-radio>
              </a-radio-group>
            </a-form-model-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-model-item :label="$t('学历')">
              <a-input :placeholder="$t('输入学历')" v-model="form.degree" :disabled="disabled"></a-input>
            </a-form-model-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-model-item :label="$t('手机号')">
              <a-input :placeholder="$t('输入手机号')" v-model="form.phoneNumber" :disabled="disabled"></a-input>
            </a-form-model-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-model-item :label="$t('固定电话')">
              <a-input :placeholder="$t('输入固定电话')" v-model="form.landline" :disabled="disabled"></a-input>
            </a-form-model-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-model-item :label="$t('工作单位')">
              <a-input :placeholder="$t('输入工作单位')" v-model="form.workplace" :disabled="disabled"></a-input>
            </a-form-model-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-model-item :label="$t('家庭住址')">
              <a-input :placeholder="$t('输入家庭住址')" v-model="form.homeAddress" :disabled="disabled"></a-input>
            </a-form-model-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-model-item :label="$t('宗教信仰')">
              <a-input :placeholder="$t('输入宗教信仰')" v-model="form.religiousBeliefs" :disabled="disabled"></a-input>
            </a-form-model-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-model-item :label="$t('住户类型')">
              <a-radio-group v-model="form.householdType" :disabled="disabled">
                <a-radio :value="1">{{ $t('租客') }}</a-radio>
                <a-radio :value="2">{{ $t('商户') }}</a-radio>
              </a-radio-group>
            </a-form-model-item>
          </a-col>
        </a-row>
      </a-form-model>
    </div>
  </a-modal>
</template>

<script>
  
  import {
    postAction
  } from '@/api/manage'
  export default{
    name:'TenantInformationModal',
    data(){
      return{
        title: '',
        width: 1000,
        visible: false,
        disabled: false,
        type: 'add',
        form:{},
      }
    },
    computed: {
      // i18n：校验消息使用 computed 以响应语言切换
      rules(){
        return {
          name:[
              { required: true, message: this.$t('请输入名称')}
          ],
        }
      }
    },
    methods:{
      init(parent,row,type){
        this.visible = true;
        this.type = type;
        if (type == 'add') {
          this.form = {};
          this.form.userKeyId = parent.id;
          this.title = this.$t('新建租户信息');
          this.disabled = false;
        } else if (type == 'edit') {
          this.form = JSON.parse(JSON.stringify(row));
          this.title = this.$t('编辑租户信息');
          this.disabled = false;
        } else {
          this.form = row;
          this.title = this.$t('租户信息详情');
          this.disabled = true;
        }
      },
      handleCancel(){
        this.visible = false;
      },
      handleSubmit(){
        let that = this;
        that.$refs.formRef.validate(valid => {
          if (valid) {
            if(this.type == 'add'){
              postAction('/jeecg-charge/meter/meterUserTenants/add', this.form).then(res => {
                if (res.success) {
                  this.visible = false;
                  this.$emit('refresh');
                }
              })
            }else{
              postAction('/jeecg-charge/meter/meterUserTenants/edit', this.form).then(res => {
                if (res.success) {
                  this.visible = false;
                  this.$emit('refresh');
                }
              })
            }
          }
        });
      },
    }
  }
</script>

<style>
</style>